import React from "react";
import PageScaffold from "../../components/PageScaffold";
import { Box } from "@chakra-ui/react";

const OrderInspectionTables = () => {
  return (
    <PageScaffold title="OrderInspectionTables" isHeaderVisible={true}>
      <Box height="calc(100vh - 64px)" width="100%">
        <iframe
          src="https://garaaz.retool.com/apps/Order%20%26%20Invoice%20Dashboard"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="OrderInspectionTables"
        />
      </Box>
    </PageScaffold>
  );
};

export default OrderInspectionTables;
